var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6884 23.2476H2.54785V21.0335H3.65488V4.42807C3.65488 4.13447 3.77151 3.85289 3.97912 3.64529C4.18673 3.43768 4.46831 3.32104 4.76191 3.32104H20.2603C20.5539 3.32104 20.8355 3.43768 21.0431 3.64529C21.2507 3.85289 21.3673 4.13447 21.3673 4.42807V9.96322H23.5814V21.0335H24.6884V23.2476ZM19.1533 21.0335H21.3673V12.1773H14.7252V21.0335H16.9392V14.3913H19.1533V21.0335ZM19.1533 9.96322V5.5351H5.86894V21.0335H12.5111V9.96322H19.1533ZM8.083 12.1773H10.2971V14.3913H8.083V12.1773ZM8.083 16.6054H10.2971V18.8195H8.083V16.6054ZM8.083 7.74916H10.2971V9.96322H8.083V7.74916Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.8c0fb3979fcbf59b5401b83da92cbe98.svg";
export { ForwardRef as ReactComponent };